/**
 * The app's single QueryClient.
 *
 * Lives in its own module (rather than inside main.tsx) so non-React code —
 * notably the account store — can drop cached data when the scope changes.
 */
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30s
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
